module.exports = __webpack_public_path__ + "static/img/icon_zhuanche.214f4e27.png";